// extracted by mini-css-extract-plugin
export default {"container":"styles_container__KZNZf","name":"styles_name__Hxfau","title":"styles_title__EhenB","body":"styles_body__rWcR4","expandButton":"styles_expandButton__5eUI3"};